import { useJwmLinkFragment } from './JwmLinkFragment.generated';
import { useShouldHideLinkingDetails } from './useShouldHideLinkingDetails';

/**
 * Will return jwmLink data for the given organization if it has a linked JWM instance.
 */
export const useJwmLinkOrganization = (orgId?: string) => {
  const { data } = useJwmLinkFragment({
    from: { id: orgId },
    variables: { orgId },
  });

  const shouldHideLinkingDetails = useShouldHideLinkingDetails(orgId);

  if (!data?.jwmLink || shouldHideLinkingDetails) {
    return null;
  }

  return data.jwmLink;
};
